export var valuesUserStateDto = ["NotFound", "NotActive", "NotInGroup", "ExistsAndInGroup", "Exists"];
/*

*/ 
//# sourceMappingURL=UserStateDto.js.map